import {NgModule, Provider} from "@angular/core";
import {BrowserModule} from "@angular/platform-browser";
import {FormsModule} from "@angular/forms";
import {Http, HttpModule} from "@angular/http";
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from "@angular/router";
// import { UpgradeModule } from "@angular/upgrade/static";
import {LocalStorageModule} from "angular-2-local-storage";
import {CookieService} from "angular2-cookie/services/cookies.service";
import {TranslateLoader, TranslateModule, TranslateService} from "@ngx-translate/core";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {FileDropModule} from "ngx-file-drop";
import {Subject} from "rxjs";

import {QUERY_PARAMS, ROUTE_REDIRECT_VALS, TCIAppMessaging, TCITenantAppType} from "@tci/common";
import {NgAppRoutingModule} from "./ng-app-routing.module";
import {NgAppComponent} from "./ng-app.component";
import {NgScriptsGoogleComponent} from "./ng-scripts/ng-scripts-google.component";
import {NgScriptsPendoComponent} from "./ng-scripts/ng-scripts-pendo.component";
import {NgAppDetailsModule} from "./ng-app-details/ng-app-details.module";
import {NgAppListModule} from "./ng-app-list/ng-app-list.module";
import {NgConnectionsModule} from "./ng-connections/ng-connections.module";
import {NgEnvToolsModule} from "./ng-env-tools/ng-env-tools.module";
import {NgEmptyModule} from "./ng-empty/ng-empty.module";
import {NgSharedModule} from "./ng-shared/ng-shared.module";
import {NgWsDiscoveryService} from "./ng-shared/ng-services/ng-ws-discovery.service";
import {NgWsService} from "./ng-shared/ng-services/ng-ws.service";
import {NgTenantsNotAvailableModule} from "./ng-tenants-not-available/ng-tenants-not-available.module";
import {NgUserExceptionsModule} from "./ng-user-exceptions/ng-user-exceptions.module";
import {NgHeaderTCIModule} from "./ng-header-tci/ng-header-tci.module";
import {TciTenantModule} from "./ng-tenant/tci-tenant.module";
import {NgMarketplaceV2Module} from "./ng-marketplace-v2/ng-marketplace-v2.module";

/* This segment is to ensure that `lru-cache` and `yallist` are included in the dependencies bundle file. */
import * as LRUCache from "lru-cache";
// Temporary d3 fix: Remove when monitoring charts are enabled
import * as d3 from "d3";

const cache = new LRUCache({ max: 0 });
/* End of segment */

declare const System: any;

d3.scale.ordinal();

class Ng2BootstrapHelper {

    public static TranslateStaticLoaderFactory(http: Http) {
        // return new TranslateStaticLoader(http, "locales", "US.json");
    }

    // public static ocLazyLoadFactory($injector: any) {
    //     return $injector.get("$ocLazyLoad");
    // }

    public static ngAppMessaging() {
        return TCIAppMessaging.getInstance(new Subject());
    }

    public static getNg1ServiceProviders(): Provider[] {
        return [
            // {
            //     provide: "ocLazyLoad",
            //     useFactory: Ng2BootstrapHelper.ocLazyLoadFactory,
            //     deps: ["$injector"]
            // },
            {
                provide: "ngAppMessaging",
                useFactory: Ng2BootstrapHelper.ngAppMessaging,
                // deps: ["$injector"]
            }
        ];
    }
}

/* This is for AoT readiness. */
export function translateLoaderFactory(http: Http) {
    return new TranslateHttpLoader(http, "./locales/", "_US.json");
}

@NgModule({
    imports: [
        NgAppRoutingModule,
        BrowserModule,
        FileDropModule,
        FormsModule,
        HttpModule,
        LocalStorageModule.withConfig({
            prefix: "tropos",
            storageType: "localStorage"
        }),
        NgAppDetailsModule,
        NgAppListModule,
        NgConnectionsModule,
        NgEnvToolsModule,
        // NgMarketplaceModule,
        NgMarketplaceV2Module,
        NgSharedModule,
        NgTenantsNotAvailableModule,
        NgUserExceptionsModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: translateLoaderFactory,
                deps: [
                    Http
                ]
            }
        }),
        // UpgradeModule,
        NgEmptyModule,
        NgHeaderTCIModule,
        TciTenantModule.forRoot()
    ],
    declarations: [
        NgAppComponent,
        NgScriptsGoogleComponent,
        NgScriptsPendoComponent
    ],
    exports: [
        NgAppComponent
    ],
    // entryComponents: [
    //     NgAppComponent
    // ],
    providers: [
        CookieService,
        Ng2BootstrapHelper.getNg1ServiceProviders(),
        NgWsDiscoveryService,
        NgWsService,

        // For IPAS-13539
        // https://stackoverflow.com/questions/40150393/how-to-redirect-to-an-external-url-from-angular2-route-without-using-component
        {
            provide: ROUTE_REDIRECT_VALS.API_SPECS_RESOLVER,
            useValue: (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
                const queryParam = route.queryParams[QUERY_PARAMS.APP_TYPE_SHORT];
                if (state.url === "/" + ROUTE_REDIRECT_VALS.API_SPECS_ROUTE ||
                    (queryParam && TCITenantAppType.fromString(queryParam).equals(TCITenantAppType.mock))) {
                    window.location.href = `${System.baseURL}${ROUTE_REDIRECT_VALS.API_SPECS_REDIRECT}`;
                }
                return null;
            }
        }
    ],
    bootstrap: [NgAppComponent]
})
export class NgAppModule {
    constructor(
        // public upgrade: UpgradeModule,
        public router: Router,
        private translate: TranslateService
    ) {
        // this language will be used as a fallback when a translation isn't found in the current language
        translate.setDefaultLang("en");

        // the lang to use, if the lang isn't available, it will use the current loader to get them
        translate.use("en");

        console.log("router config: ", this.router.config);
    }

    ngDoBootstrap() {
        // Do NOT remove this method even thought it does nothing.
    }
}
